module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/mywallet/walletloyaltycard/walletloyaltycard.component.css
// module id = ./src/app/mywallet/walletloyaltycard/walletloyaltycard.component.css
// module chunks = main